import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';
import HomeTemplate from './home-page';

const HomePage = ({ data, location }) => {
  const { frontmatter } = data?.markdownRemark || {};
  const { seo, home: content } = frontmatter ?? {};
  const { banner, media, vision, testimonials } = content ?? {};

  return (
    <HomeTemplate
      seo={seo}
      banner={banner}
      location={location}
      vision={vision}
      media={media}
      testimonials={testimonials}
    />
  );
};

HomePage.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.shape({
      frontmatter: PropTypes.object,
    }),
  }),
  location: PropTypes.object,
};

HomePage.defaultProps = {
  data: {
    markdownRemark: {
      frontmatter: {},
    },
  },
  location: undefined,
};

export default HomePage;

export const pageQuery = graphql`
  query homePage($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      fields {
        slug
      }
      frontmatter {
        seo {
          title
          description
        }
        home {
          banner {
            buttons {
              href
              label
              outline
              variant
            }
            text
            title
          }
          media {
            logos {
              image {
                childImageSharp {
                  gatsbyImageData(
                    layout: CONSTRAINED
                    height: 80
                    formats: [AUTO, WEBP, AVIF]
                    placeholder: BLURRED
                    quality: 100
                  )
                }
              }
              title
            }
            text
            title
          }
          testimonials {
            title
            stories {
              name
              text
              image {
                childImageSharp {
                  gatsbyImageData(
                    layout: CONSTRAINED
                    height: 500
                    formats: [AUTO, WEBP, AVIF]
                    placeholder: BLURRED
                    quality: 100
                  )
                }
              }
            }
          }
          vision {
            columns {
              icon {
                childImageSharp {
                  gatsbyImageData(
                    layout: CONSTRAINED
                    height: 160
                    formats: [AUTO, WEBP, AVIF]
                    placeholder: BLURRED
                    quality: 100
                  )
                }
              }
              text
              title
            }
            title
          }
        }
      }
    }
  }
`;
